import { useQuery } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import { useSelector } from 'react-redux'

import { getCurrentUser } from '@/api/user/userService'
import { QUERY_KEYS } from '@/lib/queryKeys'
import type { RootState } from '@/store/store'

export const useCurrentUser = () => {
  const isAuthenticated = useSelector((state: RootState) => state.app.isAuthenticated)

  return useQuery({
    queryKey: [QUERY_KEYS.LOGGED_USER],
    enabled: isAuthenticated,
    select: data => ({ ...(data || {}), permissions: data?.permissions || {} }),
    queryFn: () => getCurrentUser(),
    retry(failureCount, error) {
      // Dont retry if the error is 401 or 403
      if (error instanceof AxiosError && (error.response?.status === 401 || error.response?.status === 403)) {
        return false
      }
      return failureCount < 2
    },
  })
}
